/**
 * Format a date in the format "MM/DD/YYYY".
 *
 * @param {*} dotDate
 * @return {*}
 */
export const formatLongDate = (dotDate) => {
    const date = new Date(dotDate);
    const now = new Date();
    const isValidDate = !isNaN(date.getTime());
    const dateToFormat = isValidDate ? date : now;
    const formattedDate = dateToFormat.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });

    return formattedDate;
};

/**
 * Return the month, day, and year of a date.
 *
 * @param {*} dotDate
 * @return {*}
 */
export const formatShotDate = (dotDate) => {
    const date = new Date(dotDate);
    const now = new Date();
    const isValidDate = !isNaN(date.getTime());
    const dateToFormat = isValidDate ? date : now;
    const formattedDate = dateToFormat.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: '2-digit'
    });

    const [monthAndDay, year] = formattedDate.split(', ');
    const [month, day] = monthAndDay.split(' ');

    return { month, day, year };
};

/**
 * Converts a timestamp in milliseconds to an ISO 8601 date string for schema.org.
 * @param {number} timestamp - The timestamp in milliseconds (e.g., 1730223580501).
 * @returns {string} - The formatted date string (e.g., "2023-12-01T15:26:20Z").
 */
export const convertToSchemaDate = (dotDate) => {
    const date = new Date(dotDate);
    if (isNaN(date.getTime())) return dotDate;
    return date.toISOString();
};

/**
 * Formats a date string to be used in a sitemap.
 *
 * @param {string} dateString - A string containing a date and time, e.g., "2024-12-12 14:30:00".
 * @returns {string} - A string containing only the date part (in "YYYY-MM-DD" format), excluding the time.
 */
export const formatDateForSitemap = (dateString) => {
    const [datePart] = dateString.split(/T|\s/g);
    return datePart;
};
